import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';

import { LazyEditorPageCoverPicture } from '../lazyLoadables.ts';
import type { EditorPageCoverPictureEntryComponentProps } from '../pageCoverPictureTypes.ts';
import { CoverPictureStateContainer } from '../CoverPictureStateContainer.ts';

const EditorPageCoverPictureEntryComponent = ({
	contentId,
	isPublishingContent,
	contentType,
	userOffline,
	coverPictureState,
	isUnpublishedDraft,
	floatingToolbarButtonStyle,
	isFixedWidthImageOption,
	width,
	dynamicCoverImageHeight,
	isReadOnly,
	hasCoverPicture,
	aiSuggestedUnsplashImages,
	isUnsplash,
	aiHeaderImageStatus,
	aiHeaderImageFileId,
	generateAIHeaderImage,
	setAIHeaderImageStatus,
}: EditorPageCoverPictureEntryComponentProps) => {
	if (hasCoverPicture) {
		return (
			<div
				data-testid="has-cover-picture-component"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={{
					position: isFixedWidthImageOption ? 'relative' : 'absolute',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
					left: '0px',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
					right: '0px',
				}}
			>
				<LazyEditorPageCoverPicture
					contentId={contentId}
					isPublishingContent={isPublishingContent}
					contentType={contentType}
					userOffline={userOffline}
					hasCoverPicture={hasCoverPicture}
					coverPictureState={coverPictureState}
					isUnpublishedDraft={isUnpublishedDraft}
					floatingToolbarButtonStyle={floatingToolbarButtonStyle}
					width={width}
					dynamicCoverImageHeight={dynamicCoverImageHeight}
					isReadOnly={isReadOnly}
					aiSuggestedUnsplashImages={aiSuggestedUnsplashImages}
					isUnsplash={isUnsplash}
					isFixedWidthImageOption={isFixedWidthImageOption}
					aiHeaderImageStatus={aiHeaderImageStatus}
					aiHeaderImageFileId={aiHeaderImageFileId}
					generateAIHeaderImage={generateAIHeaderImage}
					setAIHeaderImageStatus={setAIHeaderImageStatus}
				/>
			</div>
		);
	}

	return (
		<div data-testid="no-cover-picture-component">
			<LazyEditorPageCoverPicture
				contentId={contentId}
				isPublishingContent={isPublishingContent}
				contentType={contentType}
				userOffline={userOffline}
				hasCoverPicture={hasCoverPicture}
				coverPictureState={coverPictureState}
				isUnpublishedDraft={isUnpublishedDraft}
				floatingToolbarButtonStyle={floatingToolbarButtonStyle}
				width={width}
				dynamicCoverImageHeight={dynamicCoverImageHeight}
				isReadOnly={isReadOnly}
				aiSuggestedUnsplashImages={aiSuggestedUnsplashImages}
				aiHeaderImageStatus={aiHeaderImageStatus}
				aiHeaderImageFileId={aiHeaderImageFileId}
				generateAIHeaderImage={generateAIHeaderImage}
				setAIHeaderImageStatus={setAIHeaderImageStatus}
			/>
		</div>
	);
};

export const EditorPageCoverPictureEntry = (props) => (
	<TransparentErrorBoundary attribution={Attribution.PAGE_EXTENSIONS}>
		<Subscribe to={[CoverPictureStateContainer]}>
			{(coverPictureState: CoverPictureStateContainer) => (
				<EditorPageCoverPictureEntryComponent {...props} coverPictureState={coverPictureState} />
			)}
		</Subscribe>
	</TransparentErrorBoundary>
);
